import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

export const ToastDefaults = {
  transition: 'fade',
  timeout: 7000,
  containerStyle: {
    left: 0,
    right: 0,
    transform: 'none',
    zIndex: 10000,
  },
  className: "g-toast-container"
};

const Toast = p => {
  let {style, options, message, close} = p;
  let type = options.type;
  let externalLink = options.externalLink;
  let typeModifierClass = `toast-wrapper--${type}`;

  let onClick = () => {
    close()
  }
  return (
    <div className={cx("g-toast")}>
      <div className={cx("toast-wrapper", typeModifierClass)}>
        {message}
      </div>
    </div>);
}
export default Toast;
